/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { Hourglass } from "lucide-react";
import { Badge } from "./ui/Badge";
import { Tooltip } from "./ui/Tooltip";
import { referralStatus } from "../lib/referrals";

/**
 * Always the stored status, so the badge can never contradict the status filter. A stale
 * baseline keeps its New label and gains an hourglass; the decay lives in the tooltip.
 */
export function ReferralStatusBadge({
  status,
  createdAt,
}: {
  status: string;
  createdAt?: string | null;
}) {
  const { label, hint, decayed } = referralStatus(status, createdAt);
  const badge = (
    <Badge tone={decayed ? "warning" : hint ? "info" : "neutral"}>
      {label}
      {decayed && (
        <Hourglass size={12} aria-label="No response in 30+ days" className="shrink-0" />
      )}
    </Badge>
  );
  return hint ? (
    <Tooltip content={hint} className="max-w-xs whitespace-normal text-left">
      {badge}
    </Tooltip>
  ) : (
    badge
  );
}
